'use client';

import { LoginForm } from '@/_components';
import { UserContext } from '@/_contexts/UserProvider';
import { useContext } from 'react';
import OverviewPage from './(admin)/overview/page';
import { ClientDashboard } from '@/_components/ClientDashboard';
import { ClientTaxReturnsProvider } from '@/_contexts/client/ClientTaxReturnsProvider';
import { ClientQuestionnaireProvider } from '@/_contexts/client/ClientQuestionnaireProvider';

export default function Home() {
  const { isLoading, isLoadingUser, isLoggedIn, isAdvisor } =
    useContext(UserContext);

  // State: Loading (empty as this is fast)
  if (isLoading || isLoadingUser) return null;

  // State: Overview
  if (isLoggedIn && isAdvisor) {
    return <OverviewPage />;
  }

  // State: Client
  if (isLoggedIn) {
    return (
      <ClientQuestionnaireProvider>
        <ClientTaxReturnsProvider>
          <ClientDashboard isPreview={false} />
        </ClientTaxReturnsProvider>
      </ClientQuestionnaireProvider>
    );
  }

  // State: Both logged out
  return <LoginForm />;
}
